import React, { useEffect, useState } from 'react';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import Footer from '../layout/Footer';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import '../../scss/updates.scss'; 
import { useDispatch } from 'react-redux';
import { parseBreadcrumbsList } from '../../store/Actions';
import getUpdates from '../actions/Updates';
import getResponse from '../actions/Project';
import form from '../../images/updates/form.png';
import task from '../../images/updates/task.png';
import file from '../../images/updates/file.png';
import { useLocation, useNavigate } from 'react-router';
import Cookies from 'js-cookie';
import Spinner from '../Reusables/Spinner';
import RefreshToken from '../actions/RefreshToken';
import LoadingOverlay from 'react-loading-overlay';
import FormSubmission from '../popups/FormSubmission';
import { convertUTCToPST } from '../Reusables/Function';

function Updates(props) {
    const token = Cookies.get('access_token');
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [selectday, SetSelectDay] = useState('');
    const [updatelist, setUpdateList] = useState([]);
    const [page, setPage] = useState(1);
    const [nextpage, setNextpage] = useState('');
    const [isLoading, setLoading] = useState(true);
    const [overlayloader, setOverlayLoader] = useState(false);
    const [formlist, setFormlistdata] = useState([]);
    const [toggle, setToggle] = useState(false);

    const [showform, setShowform] = useState(false);
    const handleFormShow = () => {
        setShowform(true);
        setToggle(!toggle)
    }
    const handleFormHide = () => setShowform(false);

    const breadcrumbsList = [
        { "name": "Home", "url": "" },
        { "name": 'Updates', "url": "updates" }
    ];

    function handleformdata(item) {
        handleFormShow();
        setFormlistdata(item);
    }

    function HandleRadio(e) {
        if(e.target.checked === true) {
            SetSelectDay(e.target.value);
            navigate(`/updates?day=${e.target.value}`);
            setPage(1);
            setUpdateList([]);
            setLoading(true);
            let scrollablelist = document.getElementsByClassName('updates-list-scroll')[0]; 
            scrollablelist.scrollTo(0, 0);
        }
    }

    function NavigateTasks(url) {
        window.open(`/projects/${url}/view#tasks`, "_blank")
    }
    function NavigateFiles(url, page) {
        if(page == "project") {
            window.open(`/projects/${url}/view#files`, "_blank")
        } 
        // else if (page == "brand") {
        //     window.open(`/portals/${url}/view#files`, "_blank")
        // } else {
        //     window.open(`/properties/${url}/view#files`, "_blank")
        // }
    }
    function NavigateForms(url) {
        window.open(`/projects/${url}/view#forms`, "_blank")
    }

    useEffect(() => {
        dispatch(parseBreadcrumbsList(breadcrumbsList));
    }, [])

    useEffect(() => {
        if(updatelist && updatelist.length > 0) {
            if(document.querySelector(`.last-update-${updatelist.length}`)) {
                const observer = new IntersectionObserver (entries => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            if(nextpage !== null) {
                                setPage(nextpage);
                                console.log("updatesloader");
                                setOverlayLoader(true);
                            }
                            observer.unobserve(entry.target);
                            return;
                        }
                    });
                }, {threshold: 0});
                observer.observe(document.querySelector(`.last-update-${updatelist.length}`));
            }
        }
    }, [isLoading, updatelist])

    useEffect(() => {
        console.log('checkuse2');
        const params = new URLSearchParams(location.search);
        const day = params.has('day') ? params.get('day') : 'this_week';
        
        function CallAPI(accesstoken) {
            var URL = `/api/updates/list?key=${day}&page=${page}&limit=10`;
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getUpdates.Updatesinfo(URL, accesstoken, (response) => {
                    if(response.status == 200) {
                        if(page === 1) {
                            setNextpage(response.data.nextPage);
                            setUpdateList(response.data.data);
                            setLoading(false);
                            document.querySelector(`input[value='${day}']`).checked = true;
                        }
                        else {
                            setNextpage(response.data.nextPage);
                            setUpdateList(updatelist.concat(response.data.data));
                            console.log("updatesloaderfinish");
                            setOverlayLoader(false);
                            document.querySelector(`input[value='${day}']`).checked = true;
                        }
                        console.log('responseupdates', response);
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    },[selectday, page])

    return (
        <div className='updates-container'>
            <Header />
            <div className='row updates-section'>
                <Sidebar />
                <div className='col-10 updates-section-right'>
                    <Breadcrumbs />
                        <div className='update-selection'>
                            <div className='show-me'>Show me updates for:</div>
                            <div className='update-selection-details'>
                                <div className='radio-button'>
                                    <input type="radio" id="today" name='radio' value="today" onChange={(e) => HandleRadio(e)}/>
                                    <label for="today">Today</label>
                                </div>
                                <div className='radio-button'>
                                    <input type="radio" id="this_week" name='radio' value="this_week" onChange={(e) => HandleRadio(e)}/>
                                    <label for="this_week">This Week</label>
                                </div>
                                <div className='radio-button'>
                                    <input type="radio" id="this_month" name='radio' value="this_month" onChange={(e) => HandleRadio(e)}/>
                                    <label for="this_month">This Month</label>
                                </div> 
                                <div className='radio-button'>
                                    <input type="radio" id="30_days" name='radio' value="30_days" onChange={(e) => HandleRadio(e)}/>
                                    <label for="30_days">Last 30 Days</label>
                                </div> 
                                <div className='radio-button'>
                                    <input type="radio" id="this_year" name='radio' value="this_year" onChange={(e) => HandleRadio(e)}/>
                                    <label for="this_year">This Year</label>
                                </div>
                            </div>
                        </div>
                        {isLoading ?
                        (<Spinner/>) :
                        (<>
                            <LoadingOverlay active={overlayloader} spinner={false} classNamePrefix='loader_'>
                                <div className='updates-list-scroll'>
                                {
                                    (updatelist && (updatelist.length === 0 || updatelist.length == null)) ? <div className="no-updates"><div>No updates available</div></div> :
                                    <div className='row updates-list-container'>
                                        { updatelist && updatelist.length > 0 && updatelist.map((item, index) => {
                                                return (
                                                    <>
                                                        {(item.formSubmission != null || item.fileClx != null || item.tasksClx != null) &&
                                                            <div className='updates-list-inner' key={index}>
                                                                <div className='updates-list'>
                                                                    <ul>
                                                                        { item.tasksClx != null && 
                                                                            <li style={{backgroundImage: `url(${task})`}} className={`last-update-${index+1}`}>
                                                                                <span className='user'>{item.tasksClx.name && item.tasksClx.name}</span>
                                                                                <span> task completed by </span>
                                                                                <span className='user'>
                                                                                    {item.user &&
                                                                                        item.user['firstName'] && item.user['firstName']
                                                                                    }
                                                                                    {' '}
                                                                                    {item.user && 
                                                                                        item.user['lastName'] && item.user['lastName']
                                                                                    }
                                                                                </span>
                                                                                <span> for project </span>
                                                                                {item.projects.hidden ? <span className='user'>{item.projects['name'] && item.projects['name']}</span>: 
                                                                                <span className='project-name' onClick={() => NavigateTasks(item.projects['idprojects'])} >{item.projects['name'] && item.projects['name']}</span>}
                                                                                
                                                                            </li> 
                                                                        }
                                                                        { item.fileClx != null && 
                                                                            <li style={{backgroundImage: `url(${file})`}} className={`last-update-${index+1}`}>
                                                                                { <a target='_blank' href={item.fileClx.fileUrl && item.fileClx.fileUrl}>{item.fileClx.fileName && item.fileClx.fileName}</a>}
                                                                                <span> file uploaded </span>
                                                                                {item.user != null && 
                                                                                <>
                                                                                <span> by </span>
                                                                                <span className='user'>
                                                                                    {item.user &&
                                                                                        item.user['firstName'] && item.user['firstName']
                                                                                    }
                                                                                    {' '}
                                                                                    {item.user && 
                                                                                        item.user['lastName'] && item.user['lastName']
                                                                                    }
                                                                                </span></>}
                                                                                {item.projects != null ? (
                                                                                    <><span> for project </span>
                                                                                    {item.projects.hidden ?  <span className='user'>{item.projects['name'] && item.projects['name']}</span> : 
                                                                                    <span className='project-name' onClick={() => NavigateFiles(item.projects['idprojects'], "project")} >{item.projects['name'] && item.projects['name']}</span>}</>
                                                                                ) : (
                                                                                    item.fileClx.brand != null ? 
                                                                                        (<><span> for portal </span>
                                                                                        {item.fileClx.brand.hidden ? <span className='user'>{item.fileClx.brand['name'] && item.fileClx.brand['name']}</span> : 
                                                                                        <span className='user' onClick={() => NavigateFiles(item.fileClx.brand['idBrand'], "brand")} >{item.fileClx.brand['name'] && item.fileClx.brand['name']}</span>}
                                                                                        </>) :
                                                                                        (<><span> for property </span>
                                                                                        {item.fileClx.entity.hidden ? <span className='user'>{item.fileClx.entity['name'] && item.fileClx.entity['name']}</span> : 
                                                                                        <span className='user' onClick={() => NavigateFiles(item.fileClx.entity['idEntities'], "entity")} >{item.fileClx.entity['name'] && item.fileClx.entity['name']}</span>}
                                                                                        </>)
                                                                                    )
                                                                                }
                                                                                
                                                                            </li> 
                                                                        }
                                                                        { item.formSubmission != null && 
                                                                            <li style={{backgroundImage: `url(${form})`}} className={`last-update-${index+1}`}>
                                                                                <span className='blue form-cursor' onClick={() => handleformdata(item.formSubmission)}>{item.formSubmission.title}</span>
                                                                                <span> submitted </span>
                                                                                {item.contact != null &&
                                                                                <>
                                                                                <span>by </span>
                                                                                <span className='user'>
                                                                                    {item.contact &&
                                                                                        item.contact['firstName'] && item.contact['firstName']
                                                                                    }
                                                                                    {' '}
                                                                                    {item.contact && 
                                                                                        item.contact['lastName'] && item.contact['lastName']
                                                                                    }
                                                                                </span></>}
                                                                                {item.projects != null && 
                                                                                    (<>
                                                                                        <span> for project </span>
                                                                                        {item.projects.hidden ? <span className='user'>{item.projects['name'] && item.projects['name']}</span> : 
                                                                                        <span className='project-name' onClick={() => NavigateForms(item.projects['idprojects'])} >{item.projects['name'] && item.projects['name']}</span>}
                                                                                    </>)}
                                                                                
                                                                                {(item.formSubmission.brand != null && <><span> for portal </span>
                                                                                <span className='user'>{item.formSubmission.brand['name'] && item.formSubmission.brand['name']}</span></>)}
                                                                            </li> 
                                                                        }
                                                                    </ul>
                                                                </div>
                                                                <div className='updates-date-list'>
                                                                    <div className='updates-date'>
                                                                        {(item.formSubmission != null || item.fileClx != null || item.tasksClx != null) && item.updateTime && convertUTCToPST(item.updateTime + 'Z', "updates")}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </>
                                                )
                                            })
                                        }
                                    </div>
                                }
                                </div>
                            </LoadingOverlay>
                        </>
                    )}
                </div>
            </div>
            { formlist &&
                <FormSubmission showform={showform} handleFormHide={handleFormHide} formlistdata={formlist} toggle={toggle} page="updates"/>
            }
            <Footer />
        </div>
    );
}

export default Updates;